import * as yup from 'yup';

import { email_or_phone_number } from 'utils/Validation';

export const ownerInfoSchema = yup.object().shape({
  name: yup.string().required('Owner name is required'),
  contactInfo: yup
    .string()
    .required('Email or phone number is required')
    .matches(email_or_phone_number, 'Must be a valid email or phone number'),
  yearOfBirth: yup
    .number()
    .typeError('Year of birth must be a number')
    .min(1900, 'Year of birth must be after 1900')
    .max(new Date().getFullYear(), 'Year of birth cannot be in the future')
    .required('Year of birth is required'),
  address: yup.string().required('Address is required'),
});
